// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"334":"1b71dbd8","406":"92069e05","453":"da2fd73d","488":"89cc6432"}[chunkId] + ".chunk.js";
};